import React, { useState, useEffect } from "react";
import PaceOfPlayIcon from "assets/svgIcons/AdminDashboard/PaceOfPlayIcon";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import _ from "lodash";
import "@progress/kendo-theme-default/dist/all.css";
import {
  Chart,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartTitle,
  ChartValueAxis,
  ChartValueAxisItem,
  ChartLegend,
  ChartSeriesDefaults,
} from "@progress/kendo-react-charts";
import "hammerjs";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const PaceOfPlay = () => {
  const { t } = useTranslation();

  const [RefreshChartHolePace, setRefreshChartHolePace] = useState(true);
  const [courseList, setCourseList] = React.useState([]);
  const { setCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const [courseIndex, setCourseIndex] = useState(setCourseId.get());
  
  const {
    siteSettingsData,
    getPaceByHoleState,
    getRoundTimeOutData,
    getCarsData,
    getCurrentCarsData,
    getMessagesFromCarsData,
    getFaultsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state.commonReducers) || "";

  const [siteIdData, setsiteIdData] = useState(null);
  const [paceByDate, setPaceByDate] = useState([]);
  const [paceValues, setPaceValues] = useState([]);

  useEffect(() => {
    if (siteIdData === null && Object?.keys(siteSettingsData)?.length !== 0)
      setsiteIdData(siteSettingsData?.Courses[0].Number);
    setCourseList(siteSettingsData);
  }, [siteSettingsData]);

  const dispatch = useDispatch();

  useEffect(() => {
    setPaceByDate([]);
    setPaceValues([]);
    setCourseIndex(setCourseId.get() - 1);
  }, [courseIndex, setCourseId.get()]);

  useEffect(() => {
    setRefreshChartHolePace(false);
  }, [getCarsData, getCurrentCarsData, getMessagesFromCarsData, getFaultsData]);

  useEffect(() => {
    setRefreshChartHolePace(true);
    setTimeout(() => setRefreshChartHolePace(false), 2000);
  }, [siteIdData]);

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    )
      dispatch(COMMON_SERVICES.getRoundTimeOutServices(siteId.get()));
  }, [getDashboardFeatureSetStatus, siteSettingsData]);

  useEffect(() => {
    if (Object?.keys(getRoundTimeOutData)?.length !== 0) {
    }
  }, [getRoundTimeOutData]);

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteSettingsData &&
      Object.keys(siteSettingsData).length > 0
    ) {
      let StartTime = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DDT00:00:00.000");
      let EndTime = moment(new Date())
        .utc()
        .utcOffset(-siteSettingsData?.TimeZoneOffset)
        .format("YYYY-MM-DDT00:00:00.000");
      dispatch(
        COMMON_SERVICES.getPaceByHoleServices(siteId.get(), StartTime, EndTime)
      );
    }

    // }
  }, [getDashboardFeatureSetStatus, siteSettingsData]);

  let paceReportsCourseList =
    courseList && courseList?.Courses && courseList?.Courses?.length;

  const [avgHoleLabels, setAvgHoleLabels] = useState([]);

  useEffect(() => {
    if (getPaceByHoleState && Object?.keys(getPaceByHoleState)?.length !== 0) {
      let tempAvgHoleLabels = [];
      let tempAvgTimeValues = [];
      let tempTargetValues = [];
      let tempBulletDataArray = [];

      if(getPaceByHoleState?.Courses) {
        for (
          var i = 0,
            paceArraylength =
              getPaceByHoleState?.Courses[courseIndex]?.AveragePace.length;
          i < paceArraylength;
          i++
        ) {
          tempAvgHoleLabels.push(i + 1);
          tempAvgTimeValues.push(
            getPaceByHoleState?.Courses[courseIndex]?.TargetPace[i] -
              getPaceByHoleState?.Courses[courseIndex]?.AveragePace[i]
          );
          tempTargetValues.push(
            getPaceByHoleState?.Courses[courseIndex]?.TargetPace[i]
          );
        }
    
        for (var i = 0, length = avgHoleLabels.length; i < length; i++) {
          tempBulletDataArray.push({
            current: tempAvgTimeValues[i],
            target: tempTargetValues[i],
            category: tempAvgHoleLabels[i],
          });
        }
        // pace value
        let tempPaceValues =
          getPaceByHoleState &&
          Object?.keys(getPaceByHoleState)?.length !== 0 &&
          getPaceByHoleState?.Courses[courseIndex]?.AveragePace?.map(
            (item) => item * -1
          );
        setAvgHoleLabels([...tempAvgHoleLabels]);
        if (tempPaceValues !== undefined) {
          setPaceValues([...tempPaceValues]);
        }
      }
    }
  }, [getPaceByHoleState, courseIndex]);

  function areAllPaceByHoleValuesZero(data, prop) {
    if (data && data !== null && data !== undefined) {
      if (Object?.keys(data)?.length !== 0 && data?.Courses && data?.Courses[courseIndex]) {
        var result = data?.Courses[courseIndex][prop]?.every(function (
          element
        ) {
          return element === 0;
        });
        return result;
      }
    }
    return true;
  }

  function formatSecsToMinsSecs(valueToFormat) {
    var formattedTime = null;
    var absValTime = null;
    if (valueToFormat >= 3600 || valueToFormat <= -3600) {
      if (valueToFormat >= 0) {
        formattedTime = moment()
          .startOf("day")
          .seconds(valueToFormat)
          .format("HH:mm:ss");
      } else {
        absValTime = Math.abs(valueToFormat);
        formattedTime =
          "-" + moment().startOf("day").seconds(absValTime).format("HH:mm:ss");
      }
    } else {
      if (valueToFormat >= 0) {
        formattedTime = moment()
          .startOf("day")
          .seconds(valueToFormat)
          .format("mm:ss");
      } else {
        absValTime = Math.abs(valueToFormat);
        formattedTime =
          "-" + moment().startOf("day").seconds(absValTime).format("mm:ss");
      }
    }
    return formattedTime;
  }
  const SharedAveragePaceTooltip = (props) => {
    const { category, points } = props;
    var formattedValue = formatSecsToMinsSecs(points[0].value);
    return (
      <div
        style={{
          backgroundColor: points[0].value > 0 ? "red" : "green",
          padding: "0px 5px 0px 5px",
        }}
      >
        {points[0].value > 0
          ? formattedValue + " " + t("behind")
          : formattedValue.replace("-", "") + " " + t("ahead")}
      </div>
    );
  };

  useEffect(() => {
    let tempMaxValue = 0;
    let tempMinValue = 0;
    for (let i = 0; i < paceByDate.length; i++) {
      if (paceByDate[i].paceValue > tempMaxValue) {
        tempMaxValue = paceByDate[i].paceValue;
      }
      if (paceByDate[i].paceValue < tempMinValue) {
        tempMinValue = paceByDate[i].paceValue;
      }
    }
  }, [paceByDate]);

  useEffect(() => {
    setRefreshChartHolePace(true);
    setTimeout(() => setRefreshChartHolePace(false), 2000);
  }, [paceValues]);

  const handleChartRefreshHolePace = (
    chartOptions,
    themeOptions,
    chartInstance
  ) => {
    if (RefreshChartHolePace) {
      chartInstance.setOptions(chartOptions, themeOptions);
    }
  };

  const sharedAveragePaceTooltipRender = (contexts) => (
    <SharedAveragePaceTooltip {...contexts} />
  );

  return (
    <>
      <div className="header">
        <PaceOfPlayIcon />
        <p className="see-green-border">{t("Pace_of_Play_Reports")}</p>
      </div>
      <div className="box-body" style={{ padding: "60px 38px 38px" }}>
        {paceValues &&
        paceValues !== undefined &&
        paceValues !== null &&
        paceValues.length !== 0 &&
        !areAllPaceByHoleValuesZero(getPaceByHoleState, "AveragePace") ? (
          <Chart onRefresh={handleChartRefreshHolePace}>
            <ChartLegend visible={false} />
            <ChartTitle text={t("Time") + " (mm:ss)"} font="14pt sans-serif" />
            <ChartSeriesItemTooltip
              border={{ color: "transparent" }}
              render={sharedAveragePaceTooltipRender}
              background="transparent"
              color="white"
              shared={true}
              visible={true}
            />
            <ChartSeriesDefaults type="column" gap={1} />

            <ChartValueAxis>
              <ChartValueAxisItem
                line={{ visible: false }}
                axisCrossingValue={[0, -99999]}
                labels={{
                  template: function (e) {
                    return formatSecsToMinsSecs(e.value);
                  },
                }}
              />
            </ChartValueAxis>
            <ChartSeries>
              <ChartSeriesItem
                gap={1}
                color={(e) => {
                  if (e.value > 0) {
                    return "red";
                  } else {
                    return "green";
                  }
                }}
                data={paceValues}
              />
            </ChartSeries>
            <ChartCategoryAxis>
              <ChartCategoryAxisItem
                categories={avgHoleLabels}
                labels={{ visible: false }}
                majorGridLines={{ visible: true }}
              />
              <ChartCategoryAxisItem
                categories={avgHoleLabels}
                majorGridLines={{ visible: true }}
                axisCrossingValue={[-99999, 1]}
              />
            </ChartCategoryAxis>
          </Chart>
        ) : (
          <>
            <div>
              <strong>{t("Time")} (mm:ss)</strong>
              <br />
              {t("No_data")}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PaceOfPlay;
